<template>
    <div class="spinner d-flex justify-content-center h-50">
        <div class="spinner-border" :class="{ 'spinner-border-sm': small }" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>
<style>
.spinner.h-auto {
    height: auto !important;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: "SpinnerLoading",
    props: {

        small: {
            type: Boolean,
            default: false as boolean,
        },
    }
});
</script>